import { Stack } from '@jarvis/web-stratus-client'

export const ECP_DOMAIN = {
  [Stack.pie]: 'https://ecp.pie.portalshell.int.hp.com/',
  [Stack.stage]: 'https://ecp.stage.portalshell.int.hp.com/',
  [Stack.prod]: 'https://hp-commandcenter.com/'
}
